<div class="qr-report-table-wrapper">
        <div class="mtn-title">
            <p>QR REPORT</p>
        </div>
    <div class="table-search">
        <label>Search</label>
        <input type="text" placeholder="Search Agent / Branch">
    </div>

    <table class="qr-report-table">
        <thead>
            <tr>
                <th>Agent Code</th>
                <th>QR Agent Name</th>
                <th>Issuing Branch</th>
                <th>Issued Quotation No</th>
                <th>Converted Policy No/s</th>
                <th>Gross Premium</th>
                <th>Net Premium</th>
                <th>Timestamp</th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let item of pagedQRReportList">
                <td>{{ item.BM_CODE }}</td>
                <td>{{ item.AGENT_NAME }}</td>
                <td>{{ item.ISS_CD }}</td>
                <td>{{ item.QUOTE_NO }}</td>
                <td>{{ item.POLICY_NO }}</td>
                <td>{{ item.GROSS_PREM }}</td>
                <td>{{ item.NET_PREM }}</td>
                <td>{{ item.CREATE_DATE | date:'yyyy-MM-dd HH:mm:ss' }}</td>
            </tr>

            <tr *ngIf="pagedQRReportList.length === 0">
                <td colspan="8" class="no-data">
                    No records found
                </td>
            </tr>
        </tbody>
    </table>

    <div class="table-footer">
        <div>
            Showing {{ (currentPage - 1) * pageSize + 1 }} to
            {{ min(currentPage * pageSize, qrReportList.length) }} of
            {{ qrReportList.length }} entries
        </div>

        <ul class="pagination">
            <li>
                <button (click)="prevPage()" [disabled]="currentPage === 1">«</button>
            </li>
            <li *ngFor="let page of pages()">
                <button
                    [class.active]="currentPage === page"
                    (click)="goToPage(page)">
                    {{ page }}
                </button>
            </li>
            <li>
                <button (click)="nextPage()" [disabled]="currentPage === totalPages">»</button>
            </li>
        </ul>
    </div>

</div>
